/**
 * NoneActionCell — the "None" zero-state for a count badge cell.
 *
 * Table cells that show a clickable count badge (devices, group members,
 * assigned groups...) previously rendered plain muted "None" text when the
 * count was zero, which forced users to reach the drawer by another route —
 * exactly when they most likely wanted to add the first item.
 *
 * This renders "None" with the same muted look, but as a real button carrying
 * the badge's action. When no handler is supplied (e.g. the user lacks manage
 * rights) it degrades to the original plain text, so permission gating is
 * preserved by simply not passing `onClick`.
 *
 * @param {{
 *   onClick?: () => void,
 *   className?: string,   // page-specific muted text class (rp-/ap-/up-)
 *   label?: string,
 *   title?: string,
 *   ariaLabel?: string,
 * }} props
 */

import './none-action-cell.css';

const NoneActionCell = ({
  onClick,
  className = '',
  label = 'None',
  title = 'Click to assign',
  ariaLabel,
}) => {
  // No handler → non-interactive, same as before.
  if (typeof onClick !== 'function') {
    return <span className={className}>{label}</span>;
  }

  return (
    <button
      type="button"
      className={`none-action ${className}`.trim()}
      // Row-level handlers (navigation, selection) must not also fire.
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      title={title}
      aria-label={ariaLabel || title}
    >
      {label}
    </button>
  );
};

export default NoneActionCell;
